import { Link } from "react-router-dom";
import { Card } from "./ui/card";
import { categoryLabel } from "../lib/articleCategories";
import TierBadge from "./TierBadge";

export default function ArticleCard({ article }) {
  const tier = article.tier_required || "free";
  return (
    <Link to={`/articles/${article.slug}`} data-testid={`article-card-${article.slug}`}>
      <Card className="group relative overflow-hidden bg-card border-white/5 hover:border-emerald-500/30 transition-all h-full flex flex-col">
        <div
          className="aspect-[16/9] bg-gradient-to-br from-emerald-500/10 to-transparent border-b border-white/5 relative overflow-hidden"
          style={
            article.cover_image
              ? { backgroundImage: `url(${article.cover_image})`, backgroundSize: "cover", backgroundPosition: "center" }
              : undefined
          }
        >
          {tier !== "free" && (
            <div className="absolute top-3 right-3">
              {/* Règle d'accès : tout abonné dès l'offre Essentiel lit les analyses premium */}
              <TierBadge tier="essentiel" locked={!!article.is_locked} blur />
            </div>
          )}
        </div>
        <div className="p-5 flex-1 flex flex-col">
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">
            {categoryLabel(article.category)}
          </div>
          <h3 className="font-display font-bold text-lg leading-tight group-hover:text-emerald-300 transition-colors">
            {article.title}
          </h3>
          <p className="mt-2 text-sm text-zinc-400 line-clamp-3 flex-1">
            {article.excerpt}
          </p>
          <div className="mt-4 pt-3 border-t border-white/5 flex items-center justify-between text-xs text-zinc-500">
            <span>{article.author}</span>
            <span>{article.created_at ? new Date(article.created_at).toLocaleDateString("fr-FR") : ""}</span>
          </div>
        </div>
      </Card>
    </Link>
  );
}
